import styled from 'styled-components/macro'

import { Tooltip, TooltipPosition } from '@loadsmart/loadsmart-ui'
import { Tag } from '@loadsmart/miranda-react'

import { isLast, type StopInfo } from '../../../domain/StopInfo'

export type ExtraStopInformationProps = {
  stops?: StopInfo[]
}

const TextWrapper = styled.span`
  display: flex;
  text-align: left;
`

export function ExtraStopInformation({ stops = [] }: ExtraStopInformationProps) {
  const middleStopsLength = stops.length

  if (middleStopsLength <= 0) return null

  return (
    <Tooltip
      position={TooltipPosition.Bottom}
      message={stops.map(({ stopSubtitle, stopTitle }, index) => (
        <div key={`en-route-stop-${index}`}>
          <TextWrapper>
            {stopTitle} <br /> {stopSubtitle} <br />
            {!isLast(index, stops) && `-`}
          </TextWrapper>
        </div>
      ))}
    >
      <Tag variant="neutral">{`+${middleStopsLength} stops`}</Tag>
    </Tooltip>
  )
}
